import Error from './error';

/**
 * @class VersionWarning
 * @extends Warning
 */
export default class CollisionError extends Error {
    constructor(type, message, icon, items, collision) {
        super(type, message, icon, items);
        this.collision = collision;
    }
}
